import { executeAction } from '@ps/workbench/undo-redo'

export function pushIVRecordAction(): void {
  executeAction({
    action: {
      value: {
        newValue: {},
        oldValue: {},
        stateDiff: undefined,
      },
      execute: () => undefined,
      undo: () => undefined,
    },
    record: true,
  })
}
